import bubbleTea0 from '../assets/bubbleTea0.svg';
import bubbleTea20 from '../assets/bubbleTea20.svg';
import bubbleTea40 from '../assets/bubbleTea40.svg';
import bubbleTea60 from '../assets/bubbleTea60.svg';
import bubbleTea80 from '../assets/bubbleTea80.svg';
import bubbleTea100 from '../assets/bubbleTea100.gif';
import cocoa0 from '../assets/cocoa0.svg';
import cocoa20 from '../assets/cocoa20.svg';
import cocoa40 from '../assets/cocoa40.svg';
import cocoa60 from '../assets/cocoa60.svg';
import cocoa80 from '../assets/cocoa80.svg';
import cocoa100 from '../assets/cocoa100.gif';
import coffee0 from '../assets/coffee0.svg';
import coffee20 from '../assets/coffee20.svg';
import coffee40 from '../assets/coffee40.svg';
import coffee60 from '../assets/coffee60.svg';
import coffee80 from '../assets/coffee80.svg';
import coffee100 from '../assets/coffee100.gif';
import juice0 from '../assets/juice0.svg';
import juice20 from '../assets/juice20.svg';
import juice40 from '../assets/juice40.svg';
import juice60 from '../assets/juice60.svg';
import juice80 from '../assets/juice80.svg';
import juice100 from '../assets/juice100.gif';
import tea0 from '../assets/tea0.svg';
import tea20 from '../assets/tea20.svg';
import tea40 from '../assets/tea40.svg';
import tea60 from '../assets/tea60.svg';
import tea80 from '../assets/tea80.svg';
import tea100 from '../assets/tea100.gif';

export enum Drink {
	BubbleTea = 'bubbleTea',
	Cocoa = 'cocoa',
	Coffee = 'coffee',
	Juice = 'juice',
	Tea = 'tea',
}

export const getMeaningfulMeterImage = (percentage: number, selectedDrink: Drink = Drink.Coffee) => {
	// NOTE: image is based on selected drink and percentage
	const tipImage = (
		{
			[Drink.BubbleTea]: {
				0: bubbleTea0,
				20: bubbleTea20,
				40: bubbleTea40,
				60: bubbleTea60,
				80: bubbleTea80,
				100: bubbleTea100,
			},
			[Drink.Cocoa]: {
				0: cocoa0,
				20: cocoa20,
				40: cocoa40,
				60: cocoa60,
				80: cocoa80,
				100: cocoa100,
			},
			[Drink.Coffee]: {
				0: coffee0,
				20: coffee20,
				40: coffee40,
				60: coffee60,
				80: coffee80,
				100: coffee100,
			},
			[Drink.Juice]: {
				0: juice0,
				20: juice20,
				40: juice40,
				60: juice60,
				80: juice80,
				100: juice100,
			},
			[Drink.Tea]: {
				0: tea0,
				20: tea20,
				40: tea40,
				60: tea60,
				80: tea80,
				100: tea100,
			},
		} as { [key in Drink]: { [key: number]: string } }
	)[selectedDrink][percentage];

	return tipImage;
};
